(function() { window.GUID_9f1b33b3_baab_40e5_8588_ad3abe42904d = { getGuid: function() { return "9f1b33b3-baab-40e5-8588-ad3abe42904d"; } }; })();
String.prototype.fixspecialchar = function () {
    return String(this)
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
    //var e = document.createElement('div');
    //e.innerHTML = this;
    //return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
};
String.prototype.replaceAll = function (search, replace) {
    if (replace === undefined || replace == "") {
        return this.toString();
    }
    return this.split(search).join(replace);
};
String.isNullOrEmpty = function (stringToTest) {
    return (stringToTest == null || stringToTest == '');
};
// Fix for IE8 trim not supported
if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, '');
    };
}
//Amelioration de fixspecialchar, indiquer comme étant plus performant. En Beta test
String.prototype.SanitizeDangerousCharacters = function () {
    let html = String(this);
    return document.createElement('div')
        .appendChild(document.createTextNode(html))
        .parentNode
        .innerHTML;
};
String.prototype.format = function (...args) {
    var a = this;
    for (var arg in args) {
        a = a.replace(new RegExp("\\{" + arg + "\\}", 'g'), arguments[arg]);
    }
    return a;
};

//# sourceMappingURL=StringExtension.js.map
